export default __webpack_public_path__ + "static/media/documents3.335fe7ad.svg";